import { FormattedMessage, useIntl } from 'react-intl';

import Button from '@atlaskit/button-next/new';
import Heading from '@atlaskit/heading';
import { Box, Stack, Text } from '@atlaskit/primitives-next';
import { BasePrimitiveProps } from '@atlaskit/primitives-next/dist/types/components/types';

import { ErrorVector, ErrorVectorNew } from '../../assets';

import { messages } from './messages';

export type GenericErrorDisplayProps = {
	iconSize?: 'small' | 'large';
	customMessage?: string;
	refreshButtonLabel?: string;
	useNewErrorVector?: boolean;
	xcss?: BasePrimitiveProps['xcss'];
	onRefresh?: () => void;
};

export const GenericErrorDisplay = ({
	iconSize = 'large',
	customMessage,
	refreshButtonLabel,
	useNewErrorVector = false,
	xcss,
	onRefresh,
}: GenericErrorDisplayProps) => {
	const intl = useIntl();

	const buttonLabel = refreshButtonLabel || intl.formatMessage(messages.defaultRefreshButtonLabel);

	return (
		<Box padding="space.400" xcss={xcss}>
			<Stack alignBlock="center" space="space.200" alignInline="center">
				{useNewErrorVector ? (
					<ErrorVectorNew
						size={iconSize}
						alt={intl.formatMessage(messages.genericErrorGraphicAltTextDecorative)}
					/>
				) : (
					<ErrorVector
						size={iconSize}
						alt={intl.formatMessage(messages.genericErrorGraphicAltText)}
					/>
				)}
				<Heading size="medium">
					<FormattedMessage {...messages.genericErrorHeading} />
				</Heading>
				{customMessage && <Text>{customMessage}</Text>}
				{onRefresh && (
					<Button appearance="primary" onClick={onRefresh}>
						{buttonLabel}
					</Button>
				)}
			</Stack>
		</Box>
	);
};
